// extracted by mini-css-extract-plugin
export default {"projectDetailScreen":"ProjectDetailScreen_projectDetailScreen__3JSwN","fadeInSection":"ProjectDetailScreen_fadeInSection__Iqtq2","fadeInUp":"ProjectDetailScreen_fadeInUp__FL551"};